import { shutDownSessionSysErrepar } from "@syserrepar/e-sessions-sdk";

export default async () => {
  console.log("Ingreso en funcion shutDownSessionSysErrepar");
  try {
    await shutDownSessionSysErrepar(() => {});
    console.log("shutDownSessionSysErrepar exitoso");
  } catch (error) {
    console.log("Fallo shutDownSessionSysErrepar:",error);
  }
  return;
};
